<template>
    <div>
        
        <table class="table">
            <thead>
                <tr>
                    <th>Invoice</th>
                    <th>SL</th>
                    <th>Type</th>
                    <th>Color</th>
                    <th>DO Pending</th>
                </tr>
            </thead>
            <tbody class="detailStockTable">
                <template v-for="dat in data" v-if="data.length > 0">
                    <tr v-for="(da, i) in dat.content" :class="{'border-top' : i == 0}">
                        <td>{{ i==0 ? dat.invoice : '' }}</td>
                        <td>{{ i==0 ? dat.sl_no ? dat.sl_no : '-' : '' }}</td>
                        <td>{{ da.type }}</td>
                        <td>{{ da.color }}</td>
                        <td>{{ numberWithCommas(da.doPending) }}</td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="100%">
                        <p class="text-center pt-5 pb-5">No Data</p>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data () {
            return {
                dummyData : null,
            }
        },
        props : ['data'],
        mounted () {
            // this.generateDummyData();
        },
        methods : {
            generateDummyData () {
                let dummy = [];

                let names = ['Beat', 'Scoopy', 'Beatstreet', 'ADV 150', 'Genio', 'ADV', 'CBR', 'Genio']
                for (var i = 0; i < 20; i++) {
                    let singleDummy = {

                        invoice : `XVI - ${2495+i}`,
                        sl_no : `SLU/0000${1681+i}/${moment().format("MM/YYYY")}/M2Z/GD1`,
                        content : []
                    }

                    for (var j = 0; j < this.randomInt(2, 5); j++) {
                        let inn = this.randomInt(1, 1000);
                        let in_transit = this.randomInt(0, 200)
                        singleDummy.content.push({
                            model : `Honda ${names[this.randomInt(0, 100)%names.length]}`,
                            color : 'All Color',
                            qty : inn + in_transit,
                            in : inn,
                            in_transit : in_transit
                        })
                    }

                    dummy.push(singleDummy);
                }

                this.dummyData = dummy;
            },
        }
    }
</script>

<style scoped>
    tbody {
        display: block;
        max-height: 65vh;
        overflow-y: scroll;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
        width: calc(100% - 10px);
    }

    thead tr th {
        border-bottom: 0.5px solid #FF0009;
        font: normal normal 500 14px/16px Ubuntu;
        color: #707070;
    }

    tbody tr td {
        font: normal normal 500 13px/14px Ubuntu;
        color: #707070;
        word-wrap: break-word;
    }

    thead tr th,
    tbody tr td {
        vertical-align: middle;
    }

    tbody tr td {
        border-top: 0;
    }

    tbody tr.border-top td:not(:first-child) {
        border-top: 1px solid #d6dadd;
    }

    .detailStockTable::-webkit-scrollbar{
        width:10px;
    }
    .detailStockTable::-webkit-scrollbar-track{
        background-color: white;
        border-radius: 20px;
    }
    .detailStockTable::-webkit-scrollbar-thumb{
        background-color: #F1F1F1;
        border-radius: 20px;
    }
</style>